import(/* webpackMode: "eager" */ "/Users/bpico/Development/nuvation/ibtrozi.com/apps/full-promo/src/app/(home)/page.js");
